module.exports = __webpack_public_path__ + "img/qrcode.e9092f20.png";